import { ApiCallState } from "../Utils";
import { Project } from "../Project/Project.type";
import { User } from "../User/User.type";
import { Staff } from "../Staff/Staff.type";

export type ProjectPayrollStatus = {
  id: number;
  project_payroll_id: number;
  user_id: number;
  status: number;
  type: "Prepared by" | "Checked by" | "Authorized by" | string;
  assigned_by: number;
  user?: User;
  assigned_user?: User;
  createdAt?: string;
  updatedAt?: string;
};

export type ProjectPayrollItem = {
  id?: number;
  project_payroll_id?: number;
  employee_id?: number;
  employee_name: string;
  job_title: string;
  salary_per_day: number;
  days_worked: number;
  gross_income: number;

  ord_hr: number;
  night_hr: number;
  sunday_hr: number;
  holiday_hr: number;
  con_hr: number;
  overtime_hr: number;

  ord_rate: number;
  night_rate: number;
  sunday_rate: number;
  holiday_rate: number;
  overtime_rate: number;
  overtime_total: number;

  total_gross_income: number;
  signature?: string;

  staff?: Staff;
};

export type ProjectPayroll = {
  id: number;
  date: string;
  project_id: number;
  period: string;
  prepared_by_id: number;
  total_gross_income: number;
  status: string;

  project?: Project;
  prepared_by?: User;
  project_payroll_items: ProjectPayrollItem[];
  project_payroll_statuses: ProjectPayrollStatus[];

  readonly createdAt?: Date;
  readonly updatedAt?: Date;
};

export const ProjectPayrollActionTypes = {
  FETCH_ALL_PROJECT_PAYROLL: "FETCH_ALL_PROJECT_PAYROLL",
  FETCH_ALL_PROJECT_PAYROLL_RESET: "FETCH_ALL_PROJECT_PAYROLL_RESET",
  FETCH_ALL_PROJECT_PAYROLL_SUCCESS: "FETCH_ALL_PROJECT_PAYROLL_SUCCESS",
  FETCH_ALL_PROJECT_PAYROLL_FAILURE: "FETCH_ALL_PROJECT_PAYROLL_FAILURE",

  FETCH_ONE_PROJECT_PAYROLL: "FETCH_ONE_PROJECT_PAYROLL",
  FETCH_ONE_PROJECT_PAYROLL_RESET: "FETCH_ONE_PROJECT_PAYROLL_RESET",
  FETCH_ONE_PROJECT_PAYROLL_SUCCESS: "FETCH_ONE_PROJECT_PAYROLL_SUCCESS",
  FETCH_ONE_PROJECT_PAYROLL_FAILURE: "FETCH_ONE_PROJECT_PAYROLL_FAILURE",
};

export type ProjectPayrollStateTypes = {
  fetchAll: ApiCallState<ProjectPayroll[]>;
  fetchOne: ApiCallState<ProjectPayroll | null>;
};
